import { push } from '@lagunovsky/redux-react-router';
import React, { FunctionComponent, useEffect, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from './logout';
import { AppDispatch, RootState } from '../../store/store';
import Loading from '../Loading/Loading';

import './Logout.css';

interface Props {
}

const Logout: FunctionComponent<Props> = ( props ) => {

  const dispatch = useDispatch<AppDispatch>();
  const logoutUri = useSelector( ( state: RootState ) => state.app.searchParameters.logout_uri );

  useEffect(() => {

    dispatch( signOut() ).then( ( action ) => {

      if ( logoutUri ) {
        location.href = logoutUri;
      } else {
        dispatch( push( '/' ) );
      }
    } );

  }, [] );


  return (
    <div className="page page-logout">
      <Loading></Loading>
    </div>
  );
}

export default Logout;
